// extracted by mini-css-extract-plugin
module.exports = {"fit":"animated_fit__oZi_d","fill":"animated_fill__Yd16U"};